import { useLocation as o, Link as a } from "@remix-run/react";
import { useState as m, useEffect as r } from "react";
import { uiEventEmitter as s } from "@made-people/grease-ui-events";
import { jsx as c } from "react/jsx-runtime";
const L = (t) => {
  const e = o(), [n, i] = m("");
  r(() => {
    n !== e.pathname && (t && t({
      from: n,
      to: e.pathname
    }), s.emit("routeChanged", {
      from: n,
      to: e.pathname
    }), i(e.pathname));
  }, [n, e.pathname]);
}, d = (t) => {
  const e = t.viewTransition ?? !0;
  return /* @__PURE__ */ c(
    a,
    {
      ...t,
      to: t.href,
      className: t.className,
      title: t.title,
      viewTransition: e,
      prefetch: "intent",
      children: t.children
    }
  );
};
export {
  d as GreaseRemixLink,
  L as useRouteChanged
};
